export default '/build/9896cde0.svg'